import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'providers/AuthProvider'
import AdminDashboard from './components/AdminDashboard';
import UserDashboard from './components/UserDashboard';
import { useNavigate } from 'react-router-dom';


const Home: React.FC = () => {

    const auth = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { setFooterClass } = useMainLayoutContext();

    useEffect(() => {
        setFooterClass('d-none d-lg-block');
        return () => {
            setFooterClass('');
        };
    }, []);


    if (auth.user === null || auth.user === undefined) {
        auth.signout(() => navigate("/"));
        return <div>Loading...</div>;
    }

    return (
        <>
            {auth.user.role === "admin" || auth.user.role === "super-admin" ? <AdminDashboard /> : <UserDashboard />}
        </>
    );
};

export default Home;